import Welcome from '@components/App/Welcome'
import { Switcher } from '@lib/components'
import useMediaQuery from '@lib/hooks/useMediaQuery'
import { AuthorizingPic, OctopusPic } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useState } from 'react'

import { TermsAndConditions } from './components/TermsAndConditions'
import Login from './legacy/Login'
import { RegisterForm } from './legacy/RegisterForm'
import css from './styles.module.css'

type Props = {
  authType: AuthType
  closeButton?: React.ReactNode
  redirectAfterAuth?: string
}

type AuthType = 'login' | 'signup'

enum AuthTab {
  Login,
  Signup,
}

interface FormProps {
  tab: AuthTab
  redirectAfterAuth?: string
}

const AuthForm: React.FC<FormProps> = ({ tab, redirectAfterAuth }) => {
  if (tab === AuthTab.Login) {
    return <Login redirectAfterAuth={redirectAfterAuth} />
  }

  return <RegisterForm redirectAfterAuth={redirectAfterAuth} />
}

export const AuthModal: React.FC<Props> = ({
  authType = 'login',
  closeButton,
  redirectAfterAuth,
}) => {
  const isTabletL = useMediaQuery('(max-width: 1023px)') // 1023 - breakpoint from which the signIn button is displayed
  const [activeTab, setActiveTab] = useState<AuthTab>(
    authType === 'login' ? AuthTab.Login : AuthTab.Signup
  )

  const authState = activeTab === AuthTab.Login

  const handleOnClose = () => {
    if (isTabletL) {
      Welcome()
    }
  }

  return (
    <div className={css.auth_container}>
      <div className={css.auth_close} onClick={handleOnClose}>
        {closeButton}
      </div>
      <div className={css.auth_header}>
        {authState ? <AuthorizingPic /> : <OctopusPic />}
      </div>
      <div className={css.auth_switcher}>
        <Switcher
          size="medium"
          onClick={(index) => setActiveTab(index)}
          items={[
            {
              content: 'Log in',
              checked: activeTab === AuthTab.Login,
            },
            {
              content: 'Sign up',
              checked: activeTab === AuthTab.Signup,
            },
          ]}
        />
      </div>
      <div>
        <AuthForm tab={activeTab} redirectAfterAuth={redirectAfterAuth} />
      </div>
      <div className={css.auth_bottom}>
        <TermsAndConditions />
      </div>
    </div>
  )
}
